import { render } from "./Earth.vue?vue&type=template&id=cbd0db66"
import script from "./Earth.vue?vue&type=script&lang=js"
export * from "./Earth.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__